module.exports = __webpack_public_path__ + "img/pr-3.c57c737b.png";